export const GENETIC_TESTS_LIST = [
    { name: 'BRCA1', value: 1 },
    { name: 'BRCA2', value: 2 },
    { name: 'MLH1', value: 3 },
    { name: 'MSH2', value: 4 },
    { name: 'MSH6', value: 5 },
    { name: 'P16', value: 6 }
];
export default GENETIC_TESTS_LIST;